import { cn } from '@pantry/ui';

/**
 * Health bar for inventory breakdown
 */
export function HealthBar({
  label,
  count,
  total,
  color,
  isLoading,
}: {
  label: string;
  count: number;
  total: number;
  color: string;
  isLoading: boolean;
}) {
  const percentage = total > 0 ? (count / total) * 100 : 0;

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm text-muted-foreground w-16">{label}</span>
      <div className="flex-1 h-2 bg-muted/50 rounded-full overflow-hidden">
        {isLoading ? (
          <div className="h-full w-1/3 animate-pulse bg-muted rounded-full" />
        ) : (
          <div
            className={cn('h-full rounded-full transition-all duration-700', color)}
            style={{ width: `${percentage}%` }}
          />
        )}
      </div>
      <span className="text-sm font-medium text-foreground w-8 text-right">
        {isLoading ? '-' : count}
      </span>
    </div>
  );
}
